import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import fire from "../../../images/fire.svg";
import crash from "../../../images/crash.svg";
import virtuals from "../../../images/virtuals.svg";
import lite from "../../../images/lite.svg";
import drops from "../../../images/drops.svg";
import slots from "../../../images/slots.svg";
import table from "../../../images/table.svg";
import live from "../../../images/live.svg";
import split from "../../../images/split.svg";
import spribe from "../../../images/spribe.svg";
import elbet from "../../../images/elbet.svg";
import pragmetic from "../../../images/pragmetic.svg";
import imoon from "../../../images/imoon.svg";
import golden from "../../../images/golden.svg";
import aviatrix from "../../../images/aviatrix.svg";
import evolution from "../../../images/evolution.svg";
import smartsoft from "../../../images/smartsoft.svg";
import kaya from "../../../images/kaya.svg";
import spinmatic from "../../../images/spinmatic.svg";
import { PROVIDERS } from "../../../utils";

const CasinoLeftPart = ({
  selectedProvider,
  setSelectedProvider,
  activeCategory,
  onCategoryChange,
}) => {
  const [isProvidersOpen, setIsProvidersOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const [showMobileProviderModal, setShowMobileProviderModal] = useState(false);
  const providersRef = useRef(null);

  // Handle closing providers list when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        providersRef.current &&
        !providersRef.current.contains(event.target)
      ) {
        setIsProvidersOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleCategoryClick = (e, categoryName) => {
    e.preventDefault(); // Prevent default link behavior
    onCategoryChange(categoryName);
  };

  const toggleMobileFilters = () => {
    setShowMobileFilters(!showMobileFilters);
  };

  const toggleProviders = () => {
    setIsProvidersOpen(!isProvidersOpen);
  };

  const toggleMobileProviderModal = () => {
    setShowMobileProviderModal(!showMobileProviderModal);
    setSearchTerm("");
  };

  const handleProviderSelect = (provider) => {
    setSelectedProvider(provider);
    // Keep providers open after selection on desktop
    setShowMobileProviderModal(false);
  };

  const filteredProviders = Object.values(PROVIDERS).filter((provider) =>
    provider.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      {/* Top navigation tabs */}
      <div className="bg-nav flex overflow-x-auto scrollbar-hide mb-1 bg-teal rounded-md">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`px-4 py-2 whitespace-nowrap text-sm ${
              activeCategory === category.name
                ? "bg-darkGreen text-white font-medium"
                : "text-white/70 hover:text-white"
            }`}
            onClick={(e) => handleCategoryClick(e, category.name)}
          >
            {category.name}
          </button>
        ))}
        <button className="px-4 py-2 whitespace-nowrap text-sm text-white/70 hover:text-white ml-auto">
          <span className="flex items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 mr-1"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z"
                clipRule="evenodd"
              />
            </svg>
            Favorites
          </span>
        </button>
      </div>

      {/* Providers section - Desktop */}
      <div
        className="hidden md:flex justify-between items-center mb-1"
        ref={providersRef}
      >
        <div className="relative flex-grow">
          {/* Providers Toggle Button */}
          {/* <button
            onClick={toggleProviders}
            className="flex items-center justify-between w-full bg-[#0B1E21] rounded-md p-3 text-white"
          >
            <span className="text-white font-medium">PROVIDERS</span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className={`h-5 w-5 transition-transform ${
                isProvidersOpen ? "transform rotate-180" : ""
              }`}
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button> */}

          {/* Providers Pills List */}

          <div className="absolute top-full left-0 right-0 mt-1 bg-teal rounded-md shadow-lg z-30 p-3">
            <div className="mb-3">
              <input
                type="text"
                placeholder="Search providers..."
                className="w-full p-2 rounded bg-darkGreen text-white text-sm"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="flex flex-wrap gap-2">
              {filteredProviders.map((provider) => (
                <button
                  key={provider.id}
                  className={`px-3 py-1 text-xs rounded-full ${
                    selectedProvider?.id === provider.id
                      ? "bg-darkGreen text-white"
                      : "bg-teal/50 text-white/70 hover:bg-darkGreen/50 hover:text-white"
                  }`}
                  onClick={() => handleProviderSelect(provider)}
                >
                  {provider.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Mobile provider button */}
      <div className="md:hidden flex justify-between items-center mb-1">
        <button
          onClick={toggleMobileProviderModal}
          className="flex items-center justify-between w-full bg-[#0B1E21] rounded-md p-3 text-white"
        >
          <div className="flex items-center">
            {selectedProvider && (
              <span className="bg-darkGreen px-3 py-1 rounded-full text-xs mr-2">
                {selectedProvider.name}
              </span>
            )}
            <span className="text-white font-medium">PROVIDERS</span>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>
      </div>

      {/* Mobile filter toggle */}
      {/* <div className="md:hidden fixed bottom-4 right-4 z-20">
        <button
          onClick={toggleMobileFilters}
          className="bg-teal text-white p-3 rounded-full shadow-lg"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"
            />
          </svg>
        </button>
      </div> */}

      {/* Mobile filters drawer */}
      {showMobileFilters && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-10 md:hidden">
          <div className="absolute bottom-0 left-0 right-0 bg-darkGreen rounded-t-lg p-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-white font-medium">Filters</h3>
              <button onClick={toggleMobileFilters} className="text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Mobile Categories */}
            <div className="mb-4">
              <h4 className="text-white/70 text-sm mb-2">Categories</h4>
              <div className="grid grid-cols-3 gap-2">
                {categories.map((category) => (
                  <button
                    key={category.id}
                    className={`px-3 py-2 text-xs rounded-md ${
                      activeCategory === category.name
                        ? "bg-teal text-white"
                        : "bg-teal/50 text-white/70 hover:text-white"
                    }`}
                    onClick={(e) => {
                      handleCategoryClick(e, category.name);
                      setShowMobileFilters(false);
                    }}
                  >
                    {category.name}
                  </button>
                ))}
              </div>
            </div>

            {/* Mobile Providers Button */}
            <div>
              <h4 className="text-white/70 text-sm mb-2">Provider</h4>
              <button
                onClick={() => {
                  toggleMobileProviderModal();
                  setShowMobileFilters(false);
                }}
                className="w-full bg-teal text-white p-2 rounded-md flex justify-between items-center"
              >
                <span className="font-medium">PROVIDERS</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M19 9l-7 7-7-7"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Provider Modal */}
      {showMobileProviderModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden">
          <div className="absolute bottom-0 left-0 right-0 bg-darkGreen rounded-t-lg p-4 max-h-[80vh] overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-white font-medium">PROVIDERS</h3>
              <button
                onClick={toggleMobileProviderModal}
                className="text-white"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Search input */}
            <div className="mb-4">
              <input
                type="text"
                placeholder="Search providers..."
                className="w-full p-3 rounded bg-teal text-white"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Provider pills in grid layout for mobile */}
            <div className="grid grid-cols-2 gap-2">
              {filteredProviders.map((provider) => (
                <button
                  key={provider.id}
                  className={`px-3 py-2 text-xs rounded-full ${
                    selectedProvider?.id === provider.id
                      ? "bg-teal text-white"
                      : "bg-teal/50 text-white/70 hover:text-white"
                  }`}
                  onClick={() => handleProviderSelect(provider)}
                >
                  {provider.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Added CSS to hide scrollbars globally */}
      <style jsx global>{`
        /* Hide scrollbar for Chrome, Safari and Opera */
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }

        /* Hide scrollbar for IE, Edge and Firefox */
        .scrollbar-hide {
          -ms-overflow-style: none; /* IE and Edge */
          scrollbar-width: none; /* Firefox */
        }
      `}</style>
    </>
  );
};

export default CasinoLeftPart;

const categories = [
  { id: 1, linktext: "/", name: "All", image: fire, count: null },
  { id: 1, linktext: "/", name: "Top", image: fire, count: null },
  { id: 1, linktext: "/", name: "New", image: fire, count: null },
  { id: 2, linktext: "/", name: "Crash", image: crash, count: 28 },
  { id: 3, linktext: "/", name: "Virtuals", image: virtuals, count: 10 },
  { id: 4, linktext: "/", name: "Lite", image: lite, count: 14 },
  { id: 5, linktext: "/", name: "Drops and …", image: drops, count: 3 },
  { id: 6, linktext: "/", name: "Slots", image: slots, count: 310 },
  { id: 7, linktext: "/", name: "Table/Cards", image: table, count: 12 },
  { id: 8, linktext: "/", name: "PragmaticLive", image: live, count: 164 },
  { id: 9, linktext: "/", name: "Popular", image: null, count: 1 },
];
